import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useRopeTypeContext } from 'src/contexts/rope-type.context';
import { actionTypes } from 'src/ducks/rope-type.duck';
import { IRopeTypeSize } from 'src/models/rope-type.model';
import { getRopeTypeStatus } from 'src/selectors/rope-type.selector';
import Lang from '../../../../libraries/language';
import style from '../rope-size-conductor-list/rope-size-conductor-list.module.scss';

type IProp = {
  data: IRopeTypeSize;
};

const RopeSizeConductorDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useRopeTypeContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getRopeTypeStatus(state, actionTypes.ROPE_TYPE_DELETE);

  const handleDelete = useCallback(async () => {
    if (data.ropeId) {
      const response = await actions.itemDELETE(data.ropeId);
      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_ROPE_DELETE_SUCCESS, data.ropeType)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_ROPE_CONDUCTOR}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data?.ropeType)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default RopeSizeConductorDelete;
